/**
 * 拓扑插件-图形、线等名称常量定义
 */
export default {
  // 默认容器ID
  defaultContainerName: 'le_tp_canvas',
  // 默认画布名称
  defaultCanvasName: 'tp_main_canvas',
  // 默认画布外层容器名称
  defaultCanvasWrapperName: 'le_tp_wrapper',
  // 默认菜单class名
  defaultMenuClassName: 'le-main-canvas-menu',
  // 默认背景颜色图形ID
  defaultBgColorShapeId: 'le_tp_background_color_id',
  // 默认画布背景色矩形名称
  defaultBgColorShapeName: 'tp_main_canvas_background_color',
  // 默认背景图片图形ID
  defaultBgImageShapeId: 'le_tp_background_image_id',
  // 默认画布背景图片图形名称
  defaultBgImageShapeName: 'tp_main_canvas_background_image',

  // 默认根分组ID
  defaultRootGroupId: '-root',
  // 默认节点分组ID
  defaultNodeGroupId: '-node',
  // 默认边分组ID
  defaultEdgeGroupId: '-edge',
  // 默认combo分组ID
  defaultComboGroupId: '-combo',
  // 默认delegate分组ID
  defaultDelegateGroupId: '-delegate',


  // 节点
  node: 'node',
  // 边（连线）
  edge: 'edge',
  // combo，类似分组
  combo: 'combo',
  // 插件
  plugins: 'plugins',
  // 网格
  grid: 'Grid',


  
  
  
  



  // 默认画布背景网格图形名称
  defaultBackgroundGridShapeName: 'tp_main_canvas_background_grid',
  // 默认图层名称前缀
  defaultLayerPrefix: 'tp_layer_',
  // 默认图层名称
  defaultLayerName: 'tp_main_layer',
  // 默认对齐辅助线图形名称
  defaultAlignmentName: 'tp_main_alignment_line',
  // 默认选择框图形名称
  defaultSelectedRectName: 'tp_main_selected_rect',
  // 默认图形Hover选择框名称
  defaultHoverRectName: 'tp_main_hover_rect',
  // 默认选择器名称
  defaultTransformerName: 'tp_main_transformer',
  // 默认画线图形选择器名称
  defaultDrawTransformerName: 'tp_main_mouse_enter_transformer',
  // 默认连线箭头图形名称
  defaultJoinLineName: 'tp_arrow_join_line',
  // 默认拓扑ID前缀，代表为前端生成的ID
  defaultIdPrefix: 'TP_',
  // 连线位于图形的顶部中间位置
  linePositionTop: 'top-center _anchor',
  // 连线位于图形的右边中间位置
  linePositionBottom: 'bottom-center _anchor',
  // 连线位于图形的左边中间位置
  linePositionLeft: 'middle-left _anchor',
  // 连线位于图形的底部中间位置
  linePositionRight: 'middle-right _anchor',
  // 默认画布放大、缩小倍数
  defaultScale: 1.5,
  // 对齐辅助线显示频率
  guideLineOffset: 10


  
};
